//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Bullet from '~/assets/svg/career-center-company-information-bullet.svg?inline';

export default {
  components: {
    Bullet,
  },
  //Путь до картинок, передаваемый через проп, должен учитывать, что в пути уже есть ~/assets/images/
  props: {
    imageSrc: {
      type: String,
      required: true,
    },
    retinaImageSrc: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    points: {
      type: Array,
      required: true,
    },
    reversed: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isPointsAvailable() {
      return this.points.length > 0;
    },
  },
};
